import styled from "@emotion/styled"
import Button from "components/Button"
import { buttonsStatesColors } from "theme/Button/constants"

export const StyledGhostTodayButton = styled(Button)`
  ${buttonsStatesColors.noBackgroundLight}
`
